import {FC} from 'react'
import clsx from 'clsx'
import {useLayout} from '../../../core/LayoutProvider'
import Logo from '../../../../assets/everyvisit-logo-white.svg'

const DefaultTitle: FC = () => {
  const {classes} = useLayout()
  return (
    <div
      // data-kt-swapper='true'
      // data-kt-swapper-mode='prepend'
      // data-kt-swapper-parent="{default: '#kt_content_container', lg: '#kt_header_container'}"
      className={clsx(
        'page-title d-flex flex-column align-items-start justify-content-center flex-wrap mt-n5 mt-lg-0 me-lg-2 pb-2 pb-lg-0'
        // classes.pageTitle.join(' ')
      )}
    >
      <div
        className='header-logo me-5 me-md-10 flex-grow-1 flex-lg-grow-0 d-none d-md-block'
        style={{opacity: 0, pointerEvents: 'none'}}
      >
        <a href='/'>
          <img alt='Logo' src={Logo} className='logo-default h-80px' />
        </a>
      </div>
    </div>
  )
}

export {DefaultTitle}
